import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { CoverLetterType } from '@core/cover-letter-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-cover-letter-type',
  templateUrl: './cover-letter-type.component.html',
  styleUrls: ['./cover-letter-type.component.less'],
  imports: [ButtonComponent, TranslatePipe, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoverLetterTypeComponent {
  public selected = output<CoverLetterType>();

  public Type = CoverLetterType;
}
